// FILE: src/components/admin/apiError.js
// The JSON body a failed admin request carried, for the extra fields some
// refusals send (e.g. 502 INVITE_EMAIL_FAILED { user }). fetchWithAuth puts
// the body in `body`; once a thunk has serialised the error it is the JSON
// in `message`. Never shown on screen: pages show errorMessage(err).
export function errorPayload(err) {
  if (!err || typeof err !== "object") return {};
  if (err.body && typeof err.body === "object") return err.body;
  if (typeof err.message === "string" && err.message.trim().startsWith("{")) {
    try {
      return JSON.parse(err.message);
    } catch {
      return {};
    }
  }
  return {};
}
